// extracted by mini-css-extract-plugin
export default {"fullWidth":"lK-z","image":"mK-z","lazyLoadPicture":"nK-z","lazyLoadSpinner":"oK-z","lazyLoadSpin":"pK-z","lazyLoadImage":"qK-z","hasStyledAspectRatio":"rK-z"};